import { render, staticRenderFns } from "./RegisterSubModuleCustomization.vue?vue&type=template&id=35b6e760&scoped=true&"
import script from "./RegisterSubModuleCustomization.vue?vue&type=script&lang=js&"
export * from "./RegisterSubModuleCustomization.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSubModuleCustomization.vue?vue&type=style&index=0&id=35b6e760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b6e760",
  null
  
)

export default component.exports